jQuery(document).ready(function($) {

    $( ".bloc_rse" ).each(function( index ) {

        $(this).find(".imageRSE").each(function( index ) {

            var image = $(this)

            gsap.fromTo( image, {
                clipPath: "inset(0% 0% 100% 0%)"
            }, {
                clipPath: "inset(0% 0% 0% 0%)",
                scrollTrigger: {
                    trigger: image,
                    start: 'top 80%',
                    end: 'top 30%',
                    scrub: 1,
                    markers: false
                }
            })

        })

    })

});